import { API_DEFAULT_TOKEN, API_ENDPOINT } from "@/components/resources/constants"

// Server-side bypass for nginx IP rate limiting during Vercel builds.
// Proxy checks `x-build-secret` against TT_BUILD_SECRET; only set on the server.
function buildHeaders(extra?: Record<string, string>): Record<string, string> {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${API_DEFAULT_TOKEN}`,
    "Content-Type": "application/json",
    ...extra,
  }
  if (typeof window === "undefined" && process.env.TT_BUILD_SECRET) {
    headers["x-build-secret"] = process.env.TT_BUILD_SECRET
  }
  return headers
}

export function getFetcher() {
  return {
    get: async <T>(path: string) => {
      const res = await fetch(API_ENDPOINT + path, {
        headers: buildHeaders(),
      })

      if (!res.ok) throw new Error(`Error fetching ${path} (status ${res.status})`)

      const data = await res.json()

      return data as T
    },
    post: async <T>(path: string, body: Record<string, string>) => {
      const res = await fetch(API_ENDPOINT + path, {
        method: "POST",
        headers: buildHeaders(),
        body: JSON.stringify(body),
      })
      const data = await res.json()

      return data as T
    },
  }
}
